import React from 'react';
import PropTypes from 'prop-types';
import './typography.scss';

export default function Typography({
  variant,
  children,
  classNames,
  weight,
  state,
  ...props
}) {
  const getClassNames = () => {
    const prefix = 'typography__';
    let style = '';
    if (classNames) style += `${classNames}`;
    if (variant) style += ` ${prefix}${variant}`;
    if (weight) style += ` ${prefix}${weight}`;
    if (state) style += ` ${prefix}${state}`;
    return style;
  };

  const getSanitisedVariant = () => {
    if (variant.startsWith('p')) return 'p';
    return variant;
  };

  props.className = getClassNames();

  return React.createElement(getSanitisedVariant(), props, children);
}

export const TypographyVariants = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  p1: 'p1',
  p2: 'p2',
  p3: 'p3',
  p4: 'p4',
};

export const TypographyWeights = {
  light: 'weight--light',
  regular: 'weight--regular',
  'semi-bold': 'weight--semi-bold',
  bold: 'weight--bold',
};

// export const TypographyFormattings = {
//   i: 'i',
//   b: 'b',
//   small: 'small',
//   strong: 'strong',
// };

export const TypographyStates = {
  success: 'success',
  error: 'error',
  neutral: 'neutral',
  'neutral-light': 'neutral-light',
  white: 'white',
  underlined: 'underlined',
  underlineOnHover: 'underlined-on-hover',
  inverted: 'inverted',
};

Typography.propTypes = {
  variant: PropTypes.oneOf(Object.values(TypographyVariants)).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
  ]).isRequired,
  weight: PropTypes.oneOf(Object.values(TypographyWeights)),
  state: PropTypes.oneOf(Object.values(TypographyStates)),
  classNames: PropTypes.string,
};

Typography.defaultProps = {
  variant: TypographyVariants.h1,
  children: null,
  weight: null,
  state: TypographyStates.neutral,
  classNames: null,
};
